import { cn, platformProps } from "../../lib";
import { Box } from "../../primitives";
import type { AccountMenuPanelFooterProps } from "./types";

/**
 * Footer slot of AccountMenuPanel — pinned to the bottom via
 * `mt-auto`. Typical content: AppDownloadStrip.
 */
export const AccountMenuPanelFooter = ({
  children,
  className,
  testID,
}: AccountMenuPanelFooterProps) => (
  <Box
    {...platformProps({ testID, slot: "account-menu-panel-footer" })}
    as="footer"
    className={cn(
      "px-spacing-lg py-spacing-md border-luce-neutral-border-mediumEmphasis mt-auto border-t",
      className,
    )}
  >
    {children}
  </Box>
);

AccountMenuPanelFooter.displayName = "AccountMenuPanel.Footer";
